<div
  [ngClass]="styleClasses()"
  class="pointer-events-none absolute z-30"
  [ngStyle]="rect() | scaleRect: dimension() | rectDisplayStyle"></div>
